import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.mjs',
	import.meta.url
).toString();

const RENDER_SCALE = 2;
const RENDER_TIMEOUT_MS = 15000;

const withTimeout = <T>(promise: Promise<T>, timeoutMs: number): Promise<T> =>
	Promise.race([
		promise,
		new Promise<T>((_, reject) => {
			setTimeout(() => reject(new Error('Tempo esgotado ao renderizar o PDF.')), timeoutMs);
		}),
	]);

const renderPdfPages = async (blob: Blob): Promise<string[]> => {
	const arrayBuffer = await blob.arrayBuffer();
	const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
	const images: string[] = [];

	for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
		const page = await pdf.getPage(pageNumber);
		const viewport = page.getViewport({ scale: RENDER_SCALE });
		const canvas = document.createElement('canvas');
		canvas.width = viewport.width;
		canvas.height = viewport.height;

		await page.render({ canvas, viewport }).promise;
		images.push(canvas.toDataURL('image/png'));
	}

	return images;
};

export const renderPdfPagesToImages = (blob: Blob): Promise<string[]> =>
	withTimeout(renderPdfPages(blob), RENDER_TIMEOUT_MS);
